import { TTRouteConfig } from "@tt-app/models";
import { ROUTES } from "@tt-app/constants";

const { USER } = ROUTES;

export const userRoutes: TTRouteConfig[] = [
  {
    name: USER.SETTINGS.NAME,
    path: USER.SETTINGS.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () => import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/UserSettings.vue")
  },
  {
    name: USER.AUTHENTICATION.LOGIN.NAME,
    path: USER.AUTHENTICATION.LOGIN.PATH,
    type: "page",
    accessLevel: "public",
    component: () => import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/Login.vue")
  },
  {
    name: USER.AUTHENTICATION.PASSWORD_CHANGE.FROM_INVITATION.NAME,
    path: USER.AUTHENTICATION.PASSWORD_CHANGE.FROM_INVITATION.PATH,
    type: "page",
    accessLevel: "public",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/PwdChangeFromInvitation.vue")
  },
  {
    name: USER.AUTHENTICATION.PASSWORD_CHANGE.FROM_REQUEST.NAME,
    path: USER.AUTHENTICATION.PASSWORD_CHANGE.FROM_REQUEST.PATH,
    type: "page",
    accessLevel: "public",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/PwdChangeFromRequest.vue")
  },
  {
    name: USER.AUTHENTICATION.PASSWORD_CHANGE.REQUEST.NAME,
    path: USER.AUTHENTICATION.PASSWORD_CHANGE.REQUEST.PATH,
    type: "page",
    accessLevel: "public",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/PwdChangeRequest.vue")
  },
  {
    name: USER.AUTHENTICATION.SSO.NAME,
    path: USER.AUTHENTICATION.SSO.PATH,
    type: "page",
    accessLevel: "public",
    component: () => import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/Sso.vue")
  },
  {
    name: USER.PRIVACY_POLICY.NAME,
    path: USER.PRIVACY_POLICY.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/UserPrivacyPolicy.vue")
  },
  {
    name: USER.TERMS_OF_SERVICES.NAME,
    path: USER.TERMS_OF_SERVICES.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/user/UserTermsOfServices.vue")
  }
];
